module.exports = __webpack_public_path__ + "static/media/2023.9.6-illustration_green_leaf_small.dc19a708.svg";